import { api } from '@src/constants/api';
import { createMiddleware, Next } from '@src/utils';
import { filesActions } from '@src/store/reducers/filesReducer';

export const createFilesMiddleware = (http: any) => {
    const restServiceUrl: string = api.restServiceUrl;
    const transformResponse = (action: any) => {
        return (data: any, header: any) => window['cTransformResponse'](data, header, action);
    }
    return createMiddleware({
        [filesActions.GET_BUILD_REPORT_FILE]: async (action: any, next: Next) => {
            const response = await http({
                method: 'POST',
                url: `${restServiceUrl}Files/Build/Job/Report`,
                data: action.payload,
                SilentRequest: action.silentRequest,
                transformResponse: transformResponse(action)
            });
            next({ type: filesActions.RECEIVE_BUILD_REPORT_FILE });
            return response;
        },
        [filesActions.DOWNLOAD_BUILD_SCRIPT]: async (action: any) => {
            const response = await http({
                method: 'GET',
                url: `${restServiceUrl}Files/Build/Job/${action.payload.jobQId}/Sql/${action.payload.index}`,
                SilentRequest: action.silentRequest,
                transformResponse: transformResponse(action)
            });
            const a: any = document.createElement('a');
            document.body.appendChild(a);
            a.style = 'display: none';
            const blob = new Blob([response.data], { type: 'application/sql' });
            const url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = `BuildScript_${action.payload.jobQId}_${action.payload.index}.sql`;
            a.click();
            window.URL.revokeObjectURL(url);
            return response.data;
        }
    });
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/store/middlewares/files.middleware.ts